import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_ADMIN_SUBSCRIPTIONS_DETAIL_API_ID =
  'DASHBOARD/FETCH_ADMIN_SUBSCRIPTIONS_DETAIL_API_ID';

const apiCall = createApiCall(
  FETCH_ADMIN_SUBSCRIPTIONS_DETAIL_API_ID,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/subscriptions/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
